import { useMutation } from '@apollo/client';

const useBackgroundMutation = query => {
  return useMutation(query, {
    context: { backgroundLoading: true }
  });
};

export default useBackgroundMutation;
